import {z} from 'zod';

export const payPerUseMonthSchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/);

export const operationTypeCountSchema = z.object({
  resource: z.string(),
  action: z.string(),
  count: z.number(),
  previousCount: z.number(),
});
export type OperationTypeCount = z.infer<typeof operationTypeCountSchema>;

export const payPerUseMetricsResponseSchema = z.object({
  month: payPerUseMonthSchema,
  from: z.string(),
  to: z.string(),
  totalCount: z.number(),
  previousTotalCount: z.number(),
  activeUserCount: z.number(),
  operationTypes: z.array(operationTypeCountSchema),
});
export type PayPerUseMetricsResponse = z.infer<typeof payPerUseMetricsResponseSchema>;

export const userOperationCountSchema = z.object({
  resource: z.string(),
  action: z.string(),
  count: z.number(),
});
export type UserOperationCount = z.infer<typeof userOperationCountSchema>;

export const leaderboardUserSchema = z.object({
  userId: z.string(),
  label: z.string(),
  total: z.number(),
  byOperationType: z.array(userOperationCountSchema),
});
export type LeaderboardUser = z.infer<typeof leaderboardUserSchema>;

export const payPerUseLeaderboardResponseSchema = z.object({
  users: z.array(leaderboardUserSchema),
});
export type PayPerUseLeaderboardResponse = z.infer<typeof payPerUseLeaderboardResponseSchema>;

export const getPayPerUseMetricsApiArgSchema = z.object({
  month: payPerUseMonthSchema,
});
export type GetPayPerUseMetricsApiArg = z.infer<typeof getPayPerUseMetricsApiArgSchema>;
export type GetPayPerUseMetricsApiResponse = PayPerUseMetricsResponse;

export const getPayPerUseLeaderboardApiArgSchema = z.object({
  month: payPerUseMonthSchema,
});
export type GetPayPerUseLeaderboardApiArg = z.infer<typeof getPayPerUseLeaderboardApiArgSchema>;
export type GetPayPerUseLeaderboardApiResponse = PayPerUseLeaderboardResponse;
